import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import pxToRem from 'assets/theme/function/px-to-rem';
import { TeamByFilterListRequest } from 'types/team/team';
import { useTeamStatusQuery, useTeamTypeQuery } from 'store/slices/team/team';
import CloseIcon from '@mui/icons-material/Close';
import { initialListData } from 'pages/team/index';

interface Props {
    setDataTeamRequestList?: React.Dispatch<
        React.SetStateAction<TeamByFilterListRequest>
    >;
}
const FilterTeam: React.FC<Props> = (props: Props) => {
    const { setDataTeamRequestList } = props;

    const { handleSubmit, control, reset } = useForm<TeamByFilterListRequest>();

    const { data: teamStatus } = useTeamStatusQuery();
    const { data: teamType } = useTeamTypeQuery();

    const onSubmit = (values: TeamByFilterListRequest) => {
        if (setDataTeamRequestList) {
            setDataTeamRequestList((prevState) => ({
                ...prevState,
                title: values.title,
                teamType: values.teamType,
                statusTeam: values.statusTeam,
                teamScore: values.teamScore,
                userCount: values.userCount,
            }));
        }
    };

    const resets = () => {
        reset();
        if (setDataTeamRequestList) {
            setDataTeamRequestList(initialListData);
        }
    };
    return (
        <Box
            pt={pxToRem(10)}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <Box display={'flex'} flexBasis={'100%'}>
                <Controller
                    name="title"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Team Title'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '30%' }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }} fullWidth>
                    <InputLabel>Team Type</InputLabel>
                    <Controller
                        name="teamType"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Team Type"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Team Type"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {teamType?.map((status) => (
                                    <MenuItem key={status} value={status}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
                <FormControl sx={{ ml: pxToRem(10), width: '30%' }} fullWidth>
                    <InputLabel>Team Status</InputLabel>
                    <Controller
                        name="statusTeam"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Team Status"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Team Status"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {teamStatus?.map((status) => (
                                    <MenuItem key={status} value={status}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>

                <Controller
                    name="userCount"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Team User Count'}
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                            sx={{ ml: pxToRem(10), width: '30%' }}
                        />
                    )}
                />

                <Controller
                    name="teamScore"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Team Score'}
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                            sx={{ ml: pxToRem(10), width: '30%' }}
                        />
                    )}
                />
            </Box>

            <Box display={'flex'} alignItems={'center'} ml={pxToRem(20)}>
                <Button
                    fullWidth
                    sx={{ mr: pxToRem(20), px: pxToRem(20) }}
                    variant={'contained'}
                    type={'submit'}
                >
                    Search
                </Button>
                <Button
                    fullWidth
                    sx={{ px: pxToRem(20) }}
                    variant={'contained'}
                    color={'secondary'}
                    onClick={resets}
                >
                    Clear
                </Button>
            </Box>
        </Box>
    );
};

export default FilterTeam;
